export default "__VITE_ASSET__Eu1wS7M$__"